import AppIcon from "../../components/AppIcon";
import { AppstoreOutlined } from "@ant-design/icons";
import { themeColors } from "../../config.js";

const AppViewer = ({ toggleAppExplorer, scale }) => {
  return (
    <AppIcon
      key={"app_viewer"}
      icon={
        <AppstoreOutlined style={{ fontSize: 30, color: themeColors.yellow }} />
      }
      name={"Applications"}
      width={100}
      height={110}
      onClick={toggleAppExplorer}
      nameOnChange={false}
      nameChangable={false}
      scale={scale}
    />
  );
};

export default AppViewer;
